import * as React from 'react';
import { Image, Header4, InlineText2 } from '@cian/ui-kit';
import { IAboutIcons } from '../../settings';
import * as styles from './AboutTabWithIcons.css';

interface IAboutTabWithIconsProps {
  icons: IAboutIcons[];
}

export function AboutTabWithIcons({ icons }: IAboutTabWithIconsProps) {
  return (
    <div className={styles['tab-with-icons']}>
      {icons.map((icon, index) => (
        <div key={index} className={styles['tab-with-icons__item']}>
          <div className={styles['tab-with-icons__item-icon']}>
            <Image src={icon.imgUrl} width={40} height={40} borderRadius="0" />
          </div>
          {icon.title && (
            <div className={styles['tab-with-icons__item-title']}>
              <Header4>{icon.title}</Header4>
            </div>
          )}
          <InlineText2>{icon.description}</InlineText2>
        </div>
      ))}
    </div>
  );
}
